export default "__VITE_ASSET__Cfo7$ppi__"